import React from 'react';
import './ServiciosSection.css';

const ServiciosSection = () => {
  const servicios = [
    {
      titulo: 'Peritaje Técnico',
      descripcion: 'Diagnóstico completo del estado mecánico, estructural y eléctrico del vehículo. Evaluación profesional para garantizar tu tranquilidad.'
    },
    {
      titulo: 'Asesoría Jurídica',
      descripcion: 'Verificación documental, revisión de antecedentes legales, embargos, multas y acompañamiento en contratos de compraventa.'
    },
    {
      titulo: 'Verificación Legal',
      descripcion: 'Consulta en RUNT, SIMIT y fuentes oficiales para detectar multas, embargos, prendas y problemas legales.'
    },
    {
      titulo: 'Acompañamiento en Compra',
      descripcion: 'Te acompañamos durante todo el proceso de compra, desde la inspección hasta la firma de documentos.'
    },
    {
      titulo: 'Informe Detallado',
      descripcion: 'Recibe un informe completo con diagnóstico técnico, análisis legal y recomendación final clara.'
    },
    {
      titulo: 'Respaldo Legal',
      descripcion: 'Protección jurídica ante fraudes, fallas ocultas o problemas documentales después de la compra.'
    }
  ];

  const iconos = {
    peritaje: (
      <svg width="50" height="50" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    asesoria: (
      <svg width="50" height="50" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2v20M2 12h20M4 4l16 16M4 20L20 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    ),
    verificacion: (
      <svg width="50" height="50" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    acompanamiento: (
      <svg width="50" height="50" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" strokeWidth="2"/>
        <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/>
      </svg>
    ),
    informe: (
      <svg width="50" height="50" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M14 2v6h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    respaldo: (
      <svg width="50" height="50" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    )
  };

  const iconosLista = [
    iconos.peritaje,
    iconos.asesoria,
    iconos.verificacion,
    iconos.acompanamiento,
    iconos.informe,
    iconos.respaldo
  ];

  return (
    <section className="servicios-section">
      <div className="container">
        <h2 className="section-title">Nuestros Servicios</h2>
        <p className="section-subtitle">Soluciones integrales para una compra segura</p>
        
        <div className="servicios-grid">
          {servicios.map((servicio, index) => (
            <div key={index} className="servicio-card">
              <div className="servicio-icono">
                {iconosLista[index]}
              </div>
              <h3>{servicio.titulo}</h3>
              <p>{servicio.descripcion}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiciosSection;